import ComponentPicker from './ComponentPicker';

export default ComponentPicker;
